import { render, staticRenderFns } from "./Registerea.vue?vue&type=template&id=0d2241e2&scoped=true&"
import script from "./Registerea.vue?vue&type=script&lang=js&"
export * from "./Registerea.vue?vue&type=script&lang=js&"
import style0 from "./Registerea.vue?vue&type=style&index=0&id=0d2241e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2241e2",
  null
  
)

export default component.exports